"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllRecordsSwaggerMetadata = getAllRecordsSwaggerMetadata;
exports.getRecordByIdSwaggerMetadata = getRecordByIdSwaggerMetadata;
exports.createRecordSwaggerMetadata = createRecordSwaggerMetadata;
exports.updateRecordByIdSwaggerMetadata = updateRecordByIdSwaggerMetadata;
exports.deleteRecordByIdSwaggerMetadata = deleteRecordByIdSwaggerMetadata;
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
function getAllRecordsSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve all records",
        description: "Fetches all records for the specified entity with optional search, sorting, and pagination.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiQuery)({
        name: "search",
        required: false,
        description: "Search term to filter records.",
        example: "example",
    }), (0, swagger_1.ApiQuery)({
        name: "searchBy",
        required: false,
        description: "Field to search by.",
        example: "name",
    }), (0, swagger_1.ApiQuery)({
        name: "sortBy",
        required: false,
        description: "Field to sort the records by.",
        example: "id",
    }), (0, swagger_1.ApiQuery)({
        name: "sortOrder",
        required: false,
        description: "Sort order (ASC or DESC).",
        example: "ASC",
    }), (0, swagger_1.ApiQuery)({
        name: "page",
        required: false,
        description: "Page number for pagination.",
        example: 1,
    }), (0, swagger_1.ApiQuery)({
        name: "limit",
        required: false,
        description: "Number of records per page(by default limit is 10 records).",
        example: 10,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Records retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Records retrieved successfully",
                },
                data: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            id: { type: "number", example: 1 },
                            name: { type: "string", example: "Example Name" },
                            description: { type: "string", example: "Example Description" },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function getRecordByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve a record by ID",
        description: "Fetches a single record by its ID for the specified entity.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "entity",
        required: true,
        description: "The name of the entity to retrieve the record for.",
        example: "User",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        required: true,
        description: "The ID of the record to retrieve.",
        example: "123",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Record retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: { type: "string", example: "Record retrieved successfully" },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                        name: { type: "string", example: "Example Name" },
                        description: { type: "string", example: "Example Description" },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Record not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function createRecordSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Create a new record",
        description: "Creates a new record for the specified entity.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "entity",
        required: true,
        description: "The name of the entity to create the record for.",
        example: "User",
    }), (0, swagger_1.ApiBody)({
        description: "Payload for creating a record.",
        schema: {
            type: "object",
            properties: {
                name: { type: "string", example: "Example Name" },
                description: { type: "string", example: "Example Description" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: "Record created successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 201 },
                message: { type: "string", example: "Record created successfully" },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                        name: { type: "string", example: "Example Name" },
                        description: { type: "string", example: "Example Description" },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function updateRecordByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Update a record by ID",
        description: "Updates an existing record by its ID for the specified entity.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "entity",
        required: true,
        description: "The name of the entity to update the record for.",
        example: "User",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        required: true,
        description: "The ID of the record to update.",
        example: "123",
    }), (0, swagger_1.ApiBody)({
        description: "Payload for updating a record.",
        schema: {
            type: "object",
            properties: {
                name: { type: "string", example: "Updated Name" },
                description: { type: "string", example: "Updated Description" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Record updated successfully.",
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Record not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function deleteRecordByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Delete a record by ID",
        description: "Deletes a record by its ID for the specified entity.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "entity",
        required: true,
        description: "The name of the entity to delete the record for.",
        example: "User",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        required: true,
        description: "The ID of the record to delete.",
        example: "123",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Record deleted successfully.",
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Record not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
